// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.1
//   protoc               v4.23.4
// source: data_platform/dispute_rates_query.proto

/* eslint-disable */

export const PaymentMethod = {
  PAYMENT_METHOD_UNSPECIFIED: "PAYMENT_METHOD_UNSPECIFIED",
  PAYMENT_METHOD_ALL_PAYMENT_METHODS: "PAYMENT_METHOD_ALL_PAYMENT_METHODS",
  PAYMENT_METHOD_ALL_CARD_AND_FINANCING: "PAYMENT_METHOD_ALL_CARD_AND_FINANCING",
  PAYMENT_METHOD_ALL_FINANCING: "PAYMENT_METHOD_ALL_FINANCING",
  PAYMENT_METHOD_SPLITIT: "PAYMENT_METHOD_SPLITIT",
  PAYMENT_METHOD_SEZZLE: "PAYMENT_METHOD_SEZZLE",
  PAYMENT_METHOD_AFTERPAY_CLEARPAY: "PAYMENT_METHOD_AFTERPAY_CLEARPAY",
  PAYMENT_METHOD_ZIP: "PAYMENT_METHOD_ZIP",
  PAYMENT_METHOD_KLARNA: "PAYMENT_METHOD_KLARNA",
  PAYMENT_METHOD_AFFIRM: "PAYMENT_METHOD_AFFIRM",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type PaymentMethod = typeof PaymentMethod[keyof typeof PaymentMethod];

export namespace PaymentMethod {
  export type PAYMENT_METHOD_UNSPECIFIED = typeof PaymentMethod.PAYMENT_METHOD_UNSPECIFIED;
  export type PAYMENT_METHOD_ALL_PAYMENT_METHODS = typeof PaymentMethod.PAYMENT_METHOD_ALL_PAYMENT_METHODS;
  export type PAYMENT_METHOD_ALL_CARD_AND_FINANCING = typeof PaymentMethod.PAYMENT_METHOD_ALL_CARD_AND_FINANCING;
  export type PAYMENT_METHOD_ALL_FINANCING = typeof PaymentMethod.PAYMENT_METHOD_ALL_FINANCING;
  export type PAYMENT_METHOD_SPLITIT = typeof PaymentMethod.PAYMENT_METHOD_SPLITIT;
  export type PAYMENT_METHOD_SEZZLE = typeof PaymentMethod.PAYMENT_METHOD_SEZZLE;
  export type PAYMENT_METHOD_AFTERPAY_CLEARPAY = typeof PaymentMethod.PAYMENT_METHOD_AFTERPAY_CLEARPAY;
  export type PAYMENT_METHOD_ZIP = typeof PaymentMethod.PAYMENT_METHOD_ZIP;
  export type PAYMENT_METHOD_KLARNA = typeof PaymentMethod.PAYMENT_METHOD_KLARNA;
  export type PAYMENT_METHOD_AFFIRM = typeof PaymentMethod.PAYMENT_METHOD_AFFIRM;
  export type UNRECOGNIZED = typeof PaymentMethod.UNRECOGNIZED;
}

export const DisputeMetric = {
  DISPUTE_METRIC_UNSPECIFIED: "DISPUTE_METRIC_UNSPECIFIED",
  DISPUTE_RATE: "DISPUTE_RATE",
  TOTAL_TRANSACTIONS: "TOTAL_TRANSACTIONS",
  DISPUTED_TRANSACTIONS: "DISPUTED_TRANSACTIONS",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type DisputeMetric = typeof DisputeMetric[keyof typeof DisputeMetric];

export namespace DisputeMetric {
  export type DISPUTE_METRIC_UNSPECIFIED = typeof DisputeMetric.DISPUTE_METRIC_UNSPECIFIED;
  export type DISPUTE_RATE = typeof DisputeMetric.DISPUTE_RATE;
  export type TOTAL_TRANSACTIONS = typeof DisputeMetric.TOTAL_TRANSACTIONS;
  export type DISPUTED_TRANSACTIONS = typeof DisputeMetric.DISPUTED_TRANSACTIONS;
  export type UNRECOGNIZED = typeof DisputeMetric.UNRECOGNIZED;
}

export const LogicalOperator = {
  LOGICAL_OPERATOR_UNSPECIFIED: "LOGICAL_OPERATOR_UNSPECIFIED",
  AND: "AND",
  OR: "OR",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type LogicalOperator = typeof LogicalOperator[keyof typeof LogicalOperator];

export namespace LogicalOperator {
  export type LOGICAL_OPERATOR_UNSPECIFIED = typeof LogicalOperator.LOGICAL_OPERATOR_UNSPECIFIED;
  export type AND = typeof LogicalOperator.AND;
  export type OR = typeof LogicalOperator.OR;
  export type UNRECOGNIZED = typeof LogicalOperator.UNRECOGNIZED;
}

export interface MetricFilter {
  paymentMethod: PaymentMethod;
  metric: DisputeMetric;
  floatRange?: FloatRange | undefined;
  intRange?: IntRange | undefined;
}

export interface QueryBnplDisputeRatesRequest {
  /** Format: "biz_abcABC" */
  bizIds: string[];
  metricFilters: MetricFilter[];
  /** Defaults to AND if unspecified */
  metricFiltersOperator: LogicalOperator;
  limit: number;
  offset: number;
}

export interface QueryBnplDisputeRatesResponse {
  records: BnplDisputeRatesRecord[];
  totalCount: number;
}

export interface BnplDisputeRatesRecord {
  bizId: string;
  paymentMethodMetrics: PaymentMethodMetrics[];
}

export interface PaymentMethodMetrics {
  paymentMethod: PaymentMethod;
  disputeRate: number;
  totalTransactions: number;
  disputedTransactions: number;
}

export interface FloatRange {
  min?: number | undefined;
  max?: number | undefined;
}

export interface IntRange {
  min?: number | undefined;
  max?: number | undefined;
}
